export default class IncompleteIncomingDataError extends Error {
  constructor(message) {
    super(message)
    this.name = 'IncompleteIncomingDataError'
  }
}

// module.exports = IncompleteIncomingDataError;
